import React from "react";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    ResponsiveContainer,
    Legend,
} from "recharts";

export default function ClassPerformanceTwoLineChart({ data }) {
    return (
        <div className="bg-white rounded-2xl shadow-md p-5">

            <ResponsiveContainer width="100%" height={388}>
                <LineChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
                    <XAxis dataKey="week" />
                    <YAxis label={{
                        value: 'Average Score %',
                        angle: -90,         // vertical
                        position: 'insideLeft',
                        offset: 10,
                        style: { textAnchor: 'middle', fill: '#555', fontWeight: 500 }
                    }} />
                    <Tooltip />


                    <Line
                        type="monotone"
                        dataKey="avg_score"
                        name="Average"
                        stroke="#3b82f6"
                        strokeWidth={2}
                        dot={{ r: 6 }}
                    />
                    <Line
                        type="monotone"
                        dataKey="target_score"
                        name="Target"
                        stroke="#16A34A"
                        strokeWidth={2}
                        dot={{ r: 6 }}
                    />
                    <Legend verticalAlign="bottom" height={30} iconType="circle" />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}
